module.exports = window.wp.keycodes;